import { FieldState } from '../Store';

export const BACCARAT: FieldState[] = [
  {
    value: '11-1',
    chip: null,
    isActive: false,
    index: 1,
    isConfirm: false,
    isWinner: false,
    activeChip: null,
    color: 'player',
    name: 'baccarat.player_pair',
    english: 'Player Pair',
    chinese: '闲对',
    backEndValue: 'player_pair',
    appliedChips: 0,
  },
  {
    value: '11-1',
    chip: null,
    isActive: false,
    index: 1,
    isConfirm: false,
    isWinner: false,
    activeChip: null,
    color: 'banker',
    name: 'baccarat.banker_pair',
    english: 'Banker Pair',
    chinese: '庄对',
    backEndValue: 'banker_pair',
    appliedChips: 0,
  },
  {
    value: '1-1',
    chip: null,
    isActive: false,
    index: 2,
    isConfirm: false,
    isWinner: false,
    activeChip: null,
    name: 'baccarat.player',
    english: 'Player',
    chinese: '闲',
    color: 'player',
    backEndValue: 'player',
    appliedChips: 0,
  },
  {
    value: '8-1',
    chip: null,
    isActive: false,
    index: 2,
    isConfirm: false,
    isWinner: false,
    activeChip: null,
    name: 'baccarat.tie',
    english: 'Tie',
    chinese: '和',
    color: 'tie',
    backEndValue: 'tie',
    appliedChips: 0,
  },
  {
    value: '0.95-1',
    chip: null,
    isActive: false,
    index: 2,
    isConfirm: false,
    isWinner: false,
    activeChip: null,
    name: 'baccarat.banker',
    english: 'Banker',
    chinese: '庄',
    color: 'banker',
    backEndValue: 'banker',
    appliedChips: 0,
  },
];
